import './SportHeader.less';

import React, { CSSProperties, FC } from 'react';
import clsx from 'clsx';

const SportHeader: FC<{
    sportId;
    sportName: string;
    otherClass?: string;
    style?: CSSProperties;
    hideBgr?: boolean;
}> = ({ sportId, sportName, otherClass, hideBgr, style, children }) => {
    return (
        <div className={clsx(`sport-header bg-${sportId}`, { [`sport-header-${sportName}`]: !hideBgr }, otherClass)}>
            {children}
        </div>
    );
};

export default SportHeader;
